import React from 'react';
import {
  Box,
  Grid,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';
import {
  ChipOption,
  ChipSelectList,
  DebouncedSearchInput,
} from '@marageti/z4-lib';
import { statusChipOptions } from './utils';

export const ratingChipOptions: ChipOption[] = [
  { key: 0, label: '5 Stars', value: '100' },
  { key: 1, label: '4 Stars', value: '80' },
  { key: 2, label: '3 Stars', value: '60' },
  { key: 3, label: '2 Stars', value: '40' },
  { key: 4, label: '1 Star', value: '20' },
];

export const sortByOptions = [
  { title: 'Oldest First', value: 'asc' },
  { title: 'Newest First', value: 'desc' },
];

type ReviewsFiltersProps = {
  onChange: (name: string, v: string | string[]) => void;
  order: string;
  searchValue: string;
  selectedRatingChips: string[];
  selectedStatusChips: string[];
  disableSortBy: boolean;
};

const ReviewsFilters = ({
  onChange,
  order,
  searchValue,
  selectedRatingChips,
  selectedStatusChips,
  disableSortBy,
}: ReviewsFiltersProps) => (
  <Box sx={{ mb: 4 }}>
    <Grid container columnSpacing={2} rowSpacing={2}>
      <Grid item xs={12} md={6} lg={3}>
        <DebouncedSearchInput
          fullWidth
          key="fullText"
          label="Search"
          name="fullText"
          onChange={(v) => onChange('fullText', v)}
          defaultValue={searchValue}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <TextField
          fullWidth
          key="sort-by-select"
          label="Order By"
          name="order"
          disabled={disableSortBy}
          onChange={(e) => onChange('order', e.target.value)}
          select
          value={order}
        >
          {sortByOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.title}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
    <Stack
      direction={{
        mobile: 'column', desktop: 'row',
      }}
      spacing={{
        mobile: 2, desktop: 4,
      }}
    >
      <ChipSelectList
        label="Rating"
        chipOptions={ratingChipOptions}
        onChange={(v: string[]) => onChange('rating', v)}
        selectedChips={selectedRatingChips}
      />
      <ChipSelectList
        label="Status"
        chipOptions={statusChipOptions}
        onChange={(v: string[]) => onChange('status', v)}
        selectedChips={selectedStatusChips}
      />
    </Stack>
  </Box>
);

export default ReviewsFilters;
